import React from 'react'
import MobileLayout from './MobileLayout'
import { useSelector } from 'react-redux'

export default function MobileDashboardPage() {
  const user = useSelector(state => state.user)

  return (
    <MobileLayout title="Dashboard">
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '10px' }}>
          Welcome, {user?.first_name || 'back'}!
        </h2>
        <p style={{ color: 'var(--secondairy-medium-gray)' }}>
          Select a section from the bottom menu to get started.
        </p>
      </div>
    </MobileLayout>
  )
}

